import React, { useState } from 'react';
import { images, heroData } from '../data/mockData';

const LogoComponent = () => {
  const [imgLoaded, setImgLoaded] = useState(true);
  
  if (imgLoaded) {
    return (
      <img
        src={images.logo}
        alt="A Healing Touch Pain Release"
        className="h-28 md:h-40 lg:h-48 w-auto drop-shadow-lg"
        onError={() => setImgLoaded(false)}
      />
    );
  }
  
  return (
    <div className="text-center drop-shadow-lg">
      <div className="flex items-center justify-center gap-2 mb-1">
        <svg className="h-12 w-12 md:h-16 md:w-16" viewBox="0 0 80 70" fill="none">
          <path d="M40 35 C30 15, 5 5, 10 30 C12 40, 25 42, 40 35" fill="#C9A84C" opacity="0.8"/>
          <path d="M40 35 C50 15, 75 5, 70 30 C68 40, 55 42, 40 35" fill="#C9A84C" opacity="0.8"/>
          <path d="M40 35 C32 45, 15 55, 20 40 C22 36, 30 38, 40 35" fill="#7B4F9E" opacity="0.7"/>
          <path d="M40 35 C48 45, 65 55, 60 40 C58 36, 50 38, 40 35" fill="#7B4F9E" opacity="0.7"/>
          <line x1="40" y1="30" x2="40" y2="60" stroke="#4A154B" strokeWidth="1.5"/>
          <line x1="40" y1="30" x2="35" y2="20" stroke="#4A154B" strokeWidth="1"/>
          <line x1="40" y1="30" x2="45" y2="20" stroke="#4A154B" strokeWidth="1"/>
        </svg>
        <div>
          <span className="font-open-sans text-[#4A154B] text-lg md:text-xl">a </span>
          <span className="font-seaweed text-[#4A154B] text-4xl md:text-6xl">healing</span>
        </div>
      </div>
      <div className="text-center -mt-2">
        <span className="font-open-sans text-[#4A154B] text-2xl md:text-3xl font-light tracking-wide">touch</span>
      </div>
      <p className="font-open-sans text-[#4A154B] text-xs md:text-sm tracking-[0.3em] uppercase mt-1">
        PAIN RELEASE
      </p>
    </div>
  );
};

const HERO_BG = 'https://customer-assets.emergentagent.com/job_energy-healing-react/artifacts/cclw6kvw_ht-bg1a.jpg';

const HeroNotice = () => {
  return (
    <>
      {/* Hero Section with background image */}
      <section
        id="home"
        className="relative overflow-hidden"
        style={{
          paddingTop: '80px',
        }}
      >
        {/* Background Image */}
        <div
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url(${HERO_BG})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />

        {/* Hero Content */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 py-12 md:py-16">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
            <LogoComponent />
            <div className="text-center md:text-left">
              <p
                className="font-seaweed text-[#C9A84C] text-xl md:text-2xl mb-1"
                style={{ textShadow: '0 2px 8px rgba(74, 21, 75, 0.7), 0 0 20px rgba(0, 0, 0, 0.3)' }}
              >
                {heroData.cta}
              </p>
              <a
                href="tel:7196842180"
                className="text-[#C9A84C] text-3xl md:text-5xl lg:text-6xl font-playfair font-bold hover:text-[#D4B85C] transition-colors duration-300"
                style={{ textShadow: '0 2px 10px rgba(74, 21, 75, 0.8), 0 0 30px rgba(0, 0, 0, 0.4)' }}
              >
                {heroData.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Gold separator bar */}
        <div
          className="h-1.5 relative z-10"
          style={{
            background: 'linear-gradient(to right, #8B5EA5, #C9A84C, #8B5EA5)',
          }}
        />
      </section>

      {/* Notice Box */}
      <section className="bg-[#F0E6F6] py-10 md:py-14 px-4">
        <div
          className="max-w-3xl mx-auto bg-white rounded-sm p-8 md:p-12 shadow-sm"
          style={{ border: '3px solid #C9A84C' }}
        >
          <p className="font-open-sans text-[#4A154B] text-base mb-6">
            Dear friends on the healing path,
          </p>
          <p className="font-open-sans text-[#4A154B] text-base mb-4 leading-relaxed">
            To make sessions more convenient and allow deeper relaxation in your own
            environment, all appointments will now be{' '}
            <strong>via phone</strong> going forward. This is{' '}
            <strong>temporary</strong> as we transition to a new location.
          </p>
          <p className="font-open-sans text-[#4A154B] text-base mb-4 leading-relaxed">
            <strong>Energy healing transcends physical space,</strong> so you'll
            receive the same loving attention and powerful shifts — often with even
            greater ease. Thank you for your understanding.
          </p>
          <p className="font-open-sans text-[#4A154B] text-base mb-6 leading-relaxed">
            Let's continue this journey together — book your phone session today!
          </p>
          <a
            href="tel:7196842180"
            className="font-playfair text-[#4A154B] text-xl font-bold underline hover:text-[#C9A84C] transition-colors duration-300"
          >
            719.684-2180
          </a>
        </div>
      </section>
    </>
  );
};

export default HeroNotice;
